<template>
  <div :class="`${prefixClass}__month-panel`">
    <!-- date header-->
    <div :class="`${prefixClass}__header`">
      <a v-if="hasPrev" :title="getJumpTitle('prev')" :class="`${prefixClass}__cmd ${prefixClass}__cmd--prev`" @click.stop="goPrevYear">
        <t-icon icon="chevron-left-outline"></t-icon>
      </a>
      <span :class="`${prefixClass}__header-label`"
            @click.stop="showYearPicker"
      >{{ drawYear }}</span>
      <a v-if="hasNext" :title="getJumpTitle('next')" :class="`${prefixClass}__cmd ${prefixClass}__cmd--next`" @click.stop="goNextYear">
        <t-icon icon="chevron-right-outline"></t-icon>
      </a>
    </div>
    <!-- date body-->
    <div :class="`${prefixClass}__body`">
      <table class="month-table flipOutY" @click.stop="handleMonthTableClick">
        <tbody>
          <tr v-for="(row, rowIndex) in rowNum" :key="`row${rowIndex}`">
            <td v-for="(col, colIndex) in getColNum(row)" :key="`col${colIndex}`" :class="getClass(row, col, this)"><a :class="disabledClass(row, col, this)" :month="getMonth(row, col)">{{ getMonthLabel(row, col) }}</a></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import { hasClass } from '../util.js'
import locale from '@/mixins/locale'
import {
  PREFIX_DATE_PICK_CLASS,
  CLASS_SELECTED,
  CLASS_DISABLED,
  CLASS_TODAY
} from '../constants'
export default {
  name: 'TMonthTable',
  mixins: [locale],
  props: {
    minSelected: {
      type: Object,
      default: () => {}
    },
    maxSelected: {
      type: Object,
      default: () => {}
    },
    minSelectRange: {
      type: Object,
      default: () => {}
    },
    maxSelectRange: {
      type: Object,
      default: () => {}
    },
    defaultDrawDate: {
      type: Object,
      default: () => {}
    },
    hasPrev: {
      type: Boolean,
      default: true
    },
    hasNext: {
      type: Boolean,
      default: true
    },
    isRange: {
      type: Boolean,
      default: false
    },
    rangeState: {
      type: Object,
      default() {
        return {
          endDate: null,
          selecting: false
        }
      }
    }
  },
  data: function() {
    return {
      prefixClass: PREFIX_DATE_PICK_CLASS,
      rowSize: 4, // one row year num
      drawDate: this.defaultDrawDate,
      drawMonth: this.defaultDrawDate.month() + 1,
      drawYear: this.defaultDrawDate.year(),
      selectedYearMonth: '',
      selectedMonth: []
    }
  },
  computed: {
    nowYearMonth() {
      return moment(
        `${new Date().getFullYear()}-${new Date().getMonth() + 1}`,
        'YYYY-MM'
      )
    },
    rowNum() {
      return Math.ceil(12 / this.rowSize)
    }
  },
  watch: {
    defaultDrawDate(newValue) {
      this.drawDate = newValue
    },
    drawDate(newValue) {
      this.drawYear = newValue.year()
    },
    minSelected(newVal, oldVal) {
      if (newVal !== null && this.drawYear === newVal.year()) {
        this.updateSelectedMonth(newVal)
        this.selectedMonth.splice(0, 1, newVal)
      }
    },
    maxSelected(newVal, oldVal) {
      if (newVal !== null && this.drawYear === newVal.year()) {
        this.updateSelectedMonth(newVal)
        this.selectedMonth.splice(1, 1, newVal)
      }
    }
  },
  created() {
    this.init()
  },
  methods: {
    getColNum(row) {
      if (row * this.rowSize <= 12) {
        return this.rowSize
      } else {
        return 12 % ((row - 1) * this.rowSize)
      }
    },
    getClass(row, col, target) {
      let month = this.getMonth(row, col)
      let current = moment(`${this.drawYear}-${month}`, 'YYYY-MM')
      let classes = []
      // 是否选中
      if (this.isRange) {
        if (current.isSame(this.minSelected) || current.isSame(this.maxSelected)) {
          classes.push(CLASS_SELECTED)
        } else if (this.minSelected && this.maxSelected && current.isBefore(this.maxSelected) && current.isAfter(this.minSelected)) {
          classes.push('date-pick--in-selected')
        }
      } else {
        if (current.isSame(this.selectedYearMonth)) {
          classes.push(CLASS_SELECTED)
        }
      }
      // 是否当前月份
      if (this.nowYearMonth.isSame(current)) {
        classes.push(CLASS_TODAY)
      }
      return classes.join(' ')
    },
    disabledClass(row, col) {
      let month = this.getMonth(row, col)
      let current = moment(`${this.drawYear}-${month}`, 'YYYY-MM')
      // disabled
      if (this.minSelectRange && current.isBefore(this.minSelectRange, 'month')) {
        return CLASS_DISABLED
      }
      if (this.maxSelectRange && current.isAfter(this.maxSelectRange, 'month')) {
        return CLASS_DISABLED
      }
    },
    getMonth(row, col) {
      if (row === 1) {
        return row * col
      } else {
        return (row - 1) * this.rowSize + col
      }
    },
    getMonthLabel(row, col) {
      let month = this.getMonth(row, col)
      return this.t(`t.datepicker.months.m${month}`)
    },
    handleMonthTableClick(event) {
      let target = event.target
      if (target.tagName !== 'A') return
      if (hasClass(target, `${PREFIX_DATE_PICK_CLASS}--disabled`)) return
      // 去掉已选择的元素的选定样式
      if (this.isRange === true) {
        let month = target.getAttribute('month')
        let newDate = moment(`${this.drawYear}-${parseInt(month)}`, 'YYYY-MM')
        // this.rangeState.selecting = !this.rangeState.selecting
        // 第2+n次选
        if (this.minSelected && this.maxSelected) {
          let maxMonth = moment(`${this.maxSelected.year()}-${this.maxSelected.month() + 1}`, 'YYYY-MM')
          let minMonth = moment(`${this.minSelected.year()}-${this.minSelected.month() + 1}`, 'YYYY-MM')
          if (newDate >= maxMonth) {
            this.selectedMonth = [this.minSelected, newDate]
          } else if (newDate >= minMonth && newDate < maxMonth) {
            this.selectedMonth = [this.minSelected, newDate]
          } else {
            this.selectedMonth = [newDate, this.maxSelected]
          }
          // 第2次选
        } else if (this.minSelected && !this.maxSelected) {
          let minMonth = moment(`${this.minSelected.year()}-${this.minSelected.month() + 1}`, 'YYYY-MM')
          if (newDate >= minMonth) {
            this.selectedMonth = [this.minSelected, newDate]
          } else {
            this.selectedMonth = [newDate, this.minSelected]
          }
          // 第1次选
        } else {
          this.selectedMonth = [newDate, this.maxSelected || null]
        }
        // 给当前元素添加选中样式
        // target.parentNode.className += ' ' + CLASS_SELECTED
        this.$emit('pick', this.selectedMonth)
      } else {
        // if (
        //   target.parentNode.parentNode.parentNode.querySelector(
        //     'td.' + CLASS_SELECTED
        //   )
        // ) {
        //   target.parentNode.parentNode.parentNode.querySelector(
        //     'td.' + CLASS_SELECTED
        //   ).className = ''
        // }
        // 给当前元素添加选中样式
        target.parentNode.className += ' ' + CLASS_SELECTED
        let month = target.getAttribute('month')
        this.selectedYearMonth = moment(`${this.drawYear}-${month}`, 'YYYY-MM')
        this.drawDate.month(month - 1)
        this.$emit('pick', this.drawDate)
      }
    },
    goPrevYear() {
      this.drawYear = this.drawDate.subtract(1, 'y').year()
      if (this.isRange === true) {
        this.$emit('changeDrawDate', this.drawDate)
      }
    },
    goNextYear() {
      this.drawYear = this.drawDate.add(1, 'y').year()
      if (this.isRange === true) {
        this.$emit('changeDrawDate', this.drawDate)
      }
    },
    // 显示年面板
    showYearPicker() {
      this.$emit('changePicker', 'year')
    },
    getJumpTitle(type) {
      return this.t(`t.datepicker.${type}Year`)
    },
    updateSelectedMonth(newDate) {
      let month = newDate.month()
      this.selectedYearMonth = moment(
        `${this.drawYear}-${month + 1}`,
        'YYYY-MM'
      )
    },
    init() {
      if (this.minSelected && moment.isMoment(this.minSelected)) {
        if (this.drawYear === this.minSelected.year()) {
          this.updateSelectedMonth(this.minSelected)
        }
        this.selectedMonth.splice(0, 1, this.minSelected)
      }
      if (this.maxSelected && moment.isMoment(this.maxSelected)) {
        if (this.drawYear === this.maxSelected.year()) {
          this.updateSelectedMonth(this.maxSelected)
        }
        this.selectedMonth.splice(1, 1, this.maxSelected)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/module/date-picker/basic/month-table.vue